module.exports = __webpack_public_path__ + "img/resource-my-active.793738ce.png";